import service from "../../services/userManagement.service";
import * as actionTypes from "./actionTypes";
import listActions from "../../helpers/listActions";
const ListActions = listActions("LIST_USERS");

export const selectUser = (row) => {
  return {
    type: actionTypes.LIST_USERS_SELECT,
    selectedRow: row,
  };
};

export const listUsers = (filterOptions, isExport = false) => {
  return (dispatch) => {
    dispatch(ListActions.start(isExport));
    console.log(
      `/user?page_number=${filterOptions.currentPage}&page_size=${
        filterOptions.page_size
      }&org_id=${filterOptions.org.value}&u_type=${
        filterOptions.userType.value
      }&sort_by=${filterOptions.sort_by}&sort_dir=${filterOptions.sort_dir}${
        filterOptions.searchKeyword.length > 0 ? "&keyword=" : ""
      }${filterOptions.searchKeyword}`
    );
    service
      .get(
        `/user?page_number=${filterOptions.currentPage}&page_size=${
          filterOptions.page_size
        }&org_id=${filterOptions.org.value}&u_type=${
          filterOptions.userType.value
        }&sort_by=${filterOptions.sort_by}&sort_dir=${filterOptions.sort_dir}${
          filterOptions.searchKeyword.length > 0 ? "&keyword=" : ""
        }${filterOptions.searchKeyword}`
      )
      .then((res) => {
        dispatch(ListActions.success(res.data, filterOptions, isExport));
      })
      .catch((err) => {
        dispatch(ListActions.fail(err, filterOptions));
      });
  };
};
